<template>
  <div v-if="showVersionUpBox" class="check-version-modal">
    <!-- 版本更新弹框 -->
    <div class="version-up-box-mask">
      <div class="version-up-box">
        <div class="version-up-box-bg">
          <div class="title">发现新版本</div>
          <div class="version">V{{ versionInfo.lastVersion }}</div>
        </div>
        <div v-if="!versionInfo.forceUpgrade" class="version-up-box-close" @click="showVersionUpBox = false" />
        <div class="version-up-box-title">发现新版本</div>
        <div class="version-up-box-item">{{ versionInfo.upgradeMsg || '更新内容' }}</div>
        <div class="partition" />
        <div class="version-up-box-btn">
          <div v-if="!isUpdate" class="btn" @click="getUpdateVersion">立即更新</div>
          <div v-else class="progress">
            <div class="progress-bg" :style="{ right: 100 - progress + '%' }" />
            <div class="progress-text">下载中 {{ progress }}%</div>
          </div>
          <div v-if="!versionInfo.forceUpgrade" class="no-update" @click="handleClose">暂不更新</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isRunningInElectron } from '@/utils/electronUtils'

export default {
  name: 'CheckVersionModal',
  props: {},
  data() {
    return {
      showVersionUpBox: false,
      versionInfo: {},
      isUpdate: false,
      progress: 0, // 更新进度
      clientDownloadUrl: ''
    }
  },
  methods: {
    show(data) {
      if (data) {
        this.versionInfo = data
        this.clientDownloadUrl = data.downloadUrl
      }
      this.showVersionUpBox = true

      window.electron.ipcRenderer.on('updateError', (event, err) => {
        console.log('updateError', event, err)
      })
      window.electron.ipcRenderer.on('updateAvailable', () => {
        console.log('updateAvailable')
      })
      window.electron.ipcRenderer.on('checkingUpdate', () => {
        console.log('checkingUpdate')
      })
      window.electron.ipcRenderer.on('updateNoAvailable', () => {
        console.log('updateNoAvailable')
      })

      this.$nextTick(() => {
        if (this.versionInfo.forceUpgrade) {
          this.getUpdateVersion()
        }
      })
    },
    handleClose() {
      this.isUpdate = false
      this.progress = 0
      this.versionInfo = {}
      this.clientDownloadUrl = ''
      this.showVersionUpBox = false
    },
    // 更新版本
    getUpdateVersion() {
      if (isRunningInElectron()) {
        if (!this.clientDownloadUrl) {
          console.error('更新客户端地址异常', this.clientDownloadUrl)
          this.$message.error('更新客户端地址异常')
        }
        // 此处需要截取最后的文件名，更新时会自动处理
        // 如：https://update.xxx.com/aiclassroom/latest.yml 或 https://update.xxx.com/aiclassroom/xxx.exe
        // 将会截取https://update.xxx.com/aiclassroom作为feedUrl用于更新
        const filename = this.clientDownloadUrl.lastIndexOf('/')
        const feedUrl = this.clientDownloadUrl.substring(0, filename)
        window.electron.ipcRenderer.send('updateClient', { feedUrl: feedUrl })
        this.isUpdate = true
        const that = this
        window.electron.ipcRenderer.on('clientUpdateDownloadProgressEvent', (event, arg) => {
          const { percent } = arg
          that.progress = percent.toFixed(2)
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.check-version-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9998;
}
.version-up-box-mask {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
}

.version-up-box {
  position: relative;
  width: 410px;
  padding: 197px 28px 20px;
  background: #ffffff;
  border-radius: 24px;

  .version-up-box-bg {
    position: absolute;
    left: 0;
    right: 0;
    top: -15px;
    width: 410px;
    height: 197px;
    background-image: url('../../assets/login/version-up-icon.png');
    background-size: 100% 100%;
    .title {
      font-weight: 400;
      font-size: 28px;
      color: #ffffff;
      margin: 50px 0 10px 20px;
    }
    .version {
      display: inline-block;
      font-size: 14px;
      color: #ffffff;
      height: 30px;
      line-height: 30px;
      padding: 0 12px;
      margin-left: 20px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 18px;
      border: 1px solid #ffffff;
    }
  }

  .version-up-box-close {
    position: absolute;
    bottom: -60px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-image: url('../../assets/login/version-close.png');
    background-size: 100% 100%;
    cursor: pointer;
  }

  .version-up-box-title {
    margin: 28px auto 14px;
    font-size: 26px;
    font-weight: 600;
    color: #1dc060;
    line-height: 37px;
    text-align: center;
  }

  .version-up-box-item {
    text-align: left;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
    margin-bottom: 14px;
    white-space: pre-line;
  }

  .partition {
    height: 1px;
    background: #e5e5e5;
    margin-bottom: 20px;
  }

  .version-up-box-btn {
    .btn {
      height: 54px;
      background: #1976ff;
      border-radius: 100px;
      font-size: 17px;
      font-weight: 400;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:hover {
        background: #0565f3;
      }
    }

    .progress {
      position: relative;
      font-size: 17px;
      font-weight: 400;
      color: #1976ff;
      line-height: 24px;
      height: 54px;
      border-radius: 50px;
      border: 1px solid #1976ff;
      background-color: #fff;
      overflow: hidden;

      .progress-bg {
        background: #e8f1ff;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
      }

      .progress-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .no-update {
      height: 54px;
      line-height: 54px;
      text-align: center;
      font-size: 17px;
      color: #666666;
      cursor: pointer;
    }
  }
}
</style>
